import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(79);
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 54,
    s: 25
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => setSpotsTaken(current => Math.min(current + 1, 94)), 45000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/50 bg-brand-taupe text-brand-cream shadow-md" data-id="element-317" data-mp="27fhxj725nkg7">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-318" data-mp="22mormfuya62j">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-319" data-mp="1xo578jw092ca">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-320" data-mp="1sqlfqiaaqt2e">
            <ClockIcon className="h-4 w-4" data-id="element-321" data-mp="2qdkj1bvhuz99" />
            <span data-id="element-322" data-mp="2qc9e38qbblgk">PRECIO DE LANZAMIENTO CIERRA EN:</span>
            <span className="rounded bg-white/15 px-2 py-0.5 font-mono font-bold tabular-nums text-white" data-id="element-323" data-mp="2ler1n8d36o3t">{time}</span>
          </div>
          <span className="h-4 w-px bg-white/25" data-id="element-324" data-mp="2ged5ankul2lm" />
          <span data-id="element-325" data-mp="2gh8yxzpnx549">
            <strong className="text-brand-goldLight" data-id="element-326" data-mp="2ce2veztxps1h">{spotsTaken}%</strong> de cupos tomados
          </span>
          <a href="#comprar" className="rounded-full bg-brand-gold px-3 py-1 text-xs font-bold text-brand-taupeDeep transition-colors duration-150 ease-out hover:bg-brand-goldLight" data-id="element-327" data-mp="150r5m8hd3ilu">
            VER PACK →
          </a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-328" data-mp="12dyw26pf3mpp">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-329" data-mp="17dl481qe2crn">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-330" data-mp="joabn7j6zool">
                <span data-id="element-331" data-mp="jnh444cesv5e">
                  ⏰ Cierra en <strong data-id="element-332" data-mp="oga8gr3yu1gy">{time}</strong>
                </span>
                <span data-id="element-333" data-mp="ohv4ym9ubuhg">•</span>
                <span data-id="element-334" data-mp="9rntiqi93bq9">
                  <strong className="text-brand-goldLight" data-id="element-335" data-mp="9sgsv6evqyyd">{spotsTaken}%</strong> de cupos tomados
                </span>
                <a href="#comprar" className="rounded-full bg-brand-gold px-2.5 py-1 text-brand-taupeDeep" data-id="element-336" data-mp="eqibjq8e8w9b">
                  VER PACK →
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}